<div class="qualification-questions-wrapper cbw-qualification-questions-wrapper" role="main" aria-label="Main section">
  @if (supportedWidgetLanguages?.length > 1 && langSwitcher) {
    <div ngbDropdown class="lang-dropdown-wrapper cbcw-lang-dropdown-wrapper">
      <button class="nav-link lang-dropdown" id="qualification-lang-dropdown" ngbDropdownToggle aria-label="Language switcher" [attr.aria-haspopup]="true" [attr.aria-expanded]="false">
        <span>
          @for (language of languages; track language) {
            @if (lang === language.locale) {
              <img width="20px" height="20px" (click)="switchLanguage(language.locale)" alt="{{ language.text }}" src="{{ deployUrl + language.flagIcon }}" />
            }
          }
        </span>
      </button>

      @if (supportedWidgetLanguages?.length > 1) {
        <div class="lang-dropdown-menu" ngbDropdownMenu aria-labelledby="qualification-lang-dropdown" role="listbox">
          @for (language of languages; track language) {
            @if (lang !== language.locale && supportedWidgetLanguages && supportedWidgetLanguages.indexOf(language.value) > -1) {
              <a ngbDropdownItem class="lang-dropdown-menu-item" href="javascript:void(0)" (click)="switchLanguage(language.locale)" role="option"  [attr.aria-label]="'Switch to '+ language.text" [attr.aria-selected]="lang === language.locale">
                <span class="d-flex justify-content-center">
                  <img width="20px" height="20px" alt="{{ language.text }}" src="{{ deployUrl + language.flagIcon }}" />
                </span>
              </a>
            }
          }
        </div>
      }
    </div>
  }

  <div class="qualification-questions cbw-qualification-questions" role="region" aria-label="Qualification Questions Form">
    @if (!widgetQualificationBasedQuestionsTitle && !widgetQualificationBasedQuestionsDescription) {
      <div class="skeleton-animation d-flex flex-column align-items-center" role="status" aria-label="Loading qualification questions">
        <div class="bar w-50 mb-2" style="height: 20px;"></div>
        <div class="bar w-100" style="height: 20px;"></div>
      </div>
    }

    @if (widgetQualificationBasedQuestionsTitle && widgetQualificationBasedQuestionsDescription) {
      <div class="heading">
        <h1 id="qualification-title">{{ widgetQualificationBasedQuestionsTitle | translation: templateContent.TEMPLATE_CONTENT: lang: partnerPlaceholders() }}</h1>
        <p id="qualification-description">{{ widgetQualificationBasedQuestionsDescription | translation: templateContent.TEMPLATE_CONTENT: lang: partnerPlaceholders() }}</p>
      </div>
    }

    <form id="qualification_question" name="qualification_question" #qualificationQuestion="ngForm" role="form" aria-label="Form">
      <app-customfields
        beforeCustomField
        [(userState)]="userState"
        [(appointmentState)]="appointmentState"
        [globals]="globals"
        [customFields]="qualificationQuestions"
        [partner]="partner()"
        [(customFieldValues)]="qualificationQuestionsValues"
        [selectedJsonCustomFields]="selectedJsonCustomFields"
        [customFieldValuesLSNameKey]="qualificationQuestionLSNameKey"
        [lang]="lang"
        [widgetTemplates]="widgetTemplates"
      />

      @if (!hideNextButton) {
        <div class="action-buttons" role="group" aria-label="Form actions">
          <calenso-button
            type="secondary"
            id="cbw-skip-qualification-question"
            customCss="cbw-skip-qualification-question"
            [disabled]="qualificationQuestion.invalid"
            [widgetColorConf]="widgetColorConf"
            [text]="widgetQualificationBasedQuestionsSkipButton | translation: templateContent.TEMPLATE_CONTENT: lang"
            (clickEvent)="skipQualificaionQuestion(qualificationQuestion.invalid)"
            aria-label="Skip Button"
          />

          <calenso-button
            type="primary"
            id="cbw-submit-qualification-question"
            customCss="cbw-submit-qualification-question"
            class="ms-2"
            placement="right"
            [widgetColorConf]="widgetColorConf"
            [text]="widgetQualificationBasedQuestionsNextButton | translation: templateContent.TEMPLATE_CONTENT: lang"
            (clickEvent)="submitQualificaionQuestion(qualificationQuestion.invalid)"
            aria-label="Next Button"
          />
        </div>
      }
    </form>
  </div>
</div>
